module.exports = __webpack_public_path__ + "media/images/loader_small-53bddfee9a5eb99fdcdea3e395a12f02.gif";